<template>
  <v-ons-page
    @show="show"
    @hide="hide"
  >
    <div class="background" />

    <div class="content">
      <div class="home-frame">
        <img
          class="show-menu"
          src="~@/assets/images/menu_button.svg"
          @click="showMenu"
        >
        <div class="home-contents">
          <v-ons-page>
            <v-ons-navigator
              :page-stack="pageStack"
              :options="options"
            />
          </v-ons-page>
        </div>

        <!--
        <slide-contents
          class="home-carousel"
        />
        -->
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import slideContents from './slider.vue';
import TWorkstyleConcierge from './contents/t_workstyle_concierge.vue';

const TWorkstyleConciergeThumb = require('@/assets/images/t_workstyle_concierge_slide.png');

export default {
  components: {
    slideContents,
  },
  computed: {
    pageStack: ({ $store }) => $store.state.homeNavigator.stack,
    options: ({ $store }) => $store.state.homeNavigator.options,
    slides: ({ $store }) => $store.state.homeNavigator.slides,
    currentSliderIndex: {
      get: ({ $store }) => $store.state.homeNavigator.currentSliderIndex,
      set(index) {
        this.$store.commit('homeNavigator/switchCurrentSlideIndex', index);
      },
    },
  },
  watch: {
    currentSliderIndex(value) {
      this.switchContent(value);
    },
  },
  created() {
    this.setSlides();
    this.switchContent(this.currentSliderIndex);
  },
  methods: {
    show() {
      if (!this.isShowSlide) return;
      // NOTE: プラグインのautoplayだと全部のアイテムが見えると次に先頭に戻ってしまうため自前で動かす
      this.$store.commit('homeNavigator/startSlideTimer');
    },
    hide() {
      this.$store.commit('homeNavigator/stopSlideTimer');
    },
    showMenu() {
      this.$store.commit('homeNavigator/toggleMenu', true);
    },
    switchContent(value) {
      this.$store.commit('homeNavigator/replace', {
        extends: this.slides[value].page,
        onsNavigatorProps: {
          title: this.slides[value].title,
        },
        onsNavigatorOptions: {
          animation: 'fade',
        },
      });
    },
    setSlides() {
      this.$store.commit('homeNavigator/setSlides', [
        {
          title: 'T-Workstyle Concierge',
          thumb: TWorkstyleConciergeThumb,
          description: '多様な働き方をIoTでサポート<br /> ※体験版サービスをご利用いただけます',
          page: TWorkstyleConcierge,
        },
      ]);
    },
  },
};
</script>

<style scoped lang="scss">
.show-menu {
  position: absolute;
  top: 40px;
  left: 40px;
  z-index: 100;
}
.background {
  background: url('~@/assets/images/background.jpg');
  background-size: cover;
  background-position: center;
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.home {
  &-frame {
    position: relative;
    width: 1920px;
    height: 1080px;
/*
    background: url('~@/assets/images/frame.svg') no-repeat center;
    background-size: cover;
*/
  }
  &-contents {
    position: absolute;
    top: 81px;
    left: 658px;
    width: 1180px;
    height: 720px;
    background: rgba(255, 255, 255, 0.2);
  }
}
.home-carousel {
  position: absolute;
  top: 866px;
  left: 658px;
  width: 1180px;
  /deep/ {
    .VueCarousel-wrapper {
    }
  }
}
.link-to-home {
  position: absolute;
  top: 866px;
  //left: 400px;
  left: 658px;
}
</style>



// WEBPACK FOOTER //
// index.vue?dd52f51e